import { GQLIdEncoder } from '../../../../../common/utils/GQLIdEncoder';
import { Operation } from '../models/Operation';
import { Key } from '../models/valueObjects/Key';
import { KeyMapper } from './valueObjects/KeyMapper';

export class OperationMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();
  private readonly keyMapper = new KeyMapper();

  mapGQLModel(data: any) {
    // The same operation could be linked to a key more than once: remove
    // duplicates from the Instance Operations display
    const keys: { [id: string]: Key } = {};
    const dataKeys = data.keys.edges ?? [];
    for (const { node } of dataKeys) {
      keys[node.id] = this.keyMapper.mapGQLModel(node);
    }
    return new Operation(this.gqlIdEncoder.decode(data.id), data.context, data.type, data.algorithms ?? [], Object.values(keys));
  }
}
